import React from 'react'


export function GoogleConfig()
{ 
 return "278700473925-uiophc9je7fquo48jrq198a5p6tuu4o8.apps.googleusercontent.com";//For Localhost:3000

 //return "759246642330-klpi21e6mucf9rd7n8ne571b5nfl1kta.apps.googleusercontent.com";//For Staging
}